module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "ded"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_c('i', [_vm._v("To my mentor and friend, Professor C. Wickham Skinner,"), _c('br'), _vm._v(" who taught me that great teaching comes from"), _c('br'), _vm._v(" preparing thoroughly, challenging the students,"), _c('br'), _vm._v(" listening carefully and respectfully,"), _c('br'), _vm._v(" constantly learning as you teach,"), _c('br'), _vm._v(" and including in every class"), _c('br'), _vm._v(" a clear, insightful, new concept.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2713a36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simm_9781118040522_oeb_ded_r1.vue
// module id = 72
// module chunks = 0